// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.html-viewer-page {
  position: absolute;
  left: 20px;
  right: 20px;
  top: 40px;
  bottom: 40px;
  z-index: 5;
  -webkit-user-select: text;
          user-select: text;
}
.scrolling-html-viewer-page {
  overflow-y: auto;
  overflow-x: auto;
  /* 设置滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

/* WebKit 浏览器滚动条样式 */
.scrolling-html-viewer-page::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.scrolling-html-viewer-page::-webkit-scrollbar-track {
  background: transparent;
}

.scrolling-html-viewer-page::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
  -webkit-transition: background-color 0.3s ease;
  transition: background-color 0.3s ease;
}

/* 鼠标悬停时显示滚动条 */
.scrolling-html-viewer-page:hover {
  scrollbar-color: #ccc transparent;
}

.scrolling-html-viewer-page:hover::-webkit-scrollbar-thumb {
  background: #ccc;
}

.scrolling-html-viewer-page:hover::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}

.popup-menu-container {
  position: absolute;
  left: 100px;
  top: 100px;
  z-index: 20;
  animation: popup 0.075s ease-in-out 0s 1;
}
.bookmark {
  height: 40px;
  width: 20px;
  padding: 0px;
  transform: rotate(0deg) skew(0deg);
  border-left: 10px solid red;
  border-right: 10px solid red;
  border-bottom: 10px solid transparent;
  position: fixed;
  top: 5px;
  right: 70px;
  z-index: 15;
}
.bookmark,
.bookmark:before,
.bookmark:after {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -150px;
  margin-top: -50px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/viewer/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,YAAY;EACZ,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,8CAAsC;EAAtC,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EAEZ,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;EACrC,eAAe;EACf,QAAQ;EACR,WAAW;EACX,WAAW;AACb;AACA;;;EAGE,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".html-viewer-page {\n  position: absolute;\n  left: 20px;\n  right: 20px;\n  top: 40px;\n  bottom: 40px;\n  z-index: 5;\n  user-select: text;\n}\n.scrolling-html-viewer-page {\n  overflow-y: auto;\n  overflow-x: auto;\n  /* 设置滚动条样式 */\n  scrollbar-width: thin;\n  scrollbar-color: transparent transparent;\n}\n\n/* WebKit 浏览器滚动条样式 */\n.scrolling-html-viewer-page::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.scrolling-html-viewer-page::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scrolling-html-viewer-page::-webkit-scrollbar-thumb {\n  background: transparent;\n  border-radius: 4px;\n  transition: background-color 0.3s ease;\n}\n\n/* 鼠标悬停时显示滚动条 */\n.scrolling-html-viewer-page:hover {\n  scrollbar-color: #ccc transparent;\n}\n\n.scrolling-html-viewer-page:hover::-webkit-scrollbar-thumb {\n  background: #ccc;\n}\n\n.scrolling-html-viewer-page:hover::-webkit-scrollbar-thumb:hover {\n  background: #ccc;\n}\n\n.popup-menu-container {\n  position: absolute;\n  left: 100px;\n  top: 100px;\n  z-index: 20;\n  animation: popup 0.075s ease-in-out 0s 1;\n}\n.bookmark {\n  height: 40px;\n  width: 20px;\n  padding: 0px;\n  -webkit-transform: rotate(0deg) skew(0deg);\n  transform: rotate(0deg) skew(0deg);\n  border-left: 10px solid red;\n  border-right: 10px solid red;\n  border-bottom: 10px solid transparent;\n  position: fixed;\n  top: 5px;\n  right: 70px;\n  z-index: 15;\n}\n.bookmark,\n.bookmark:before,\n.bookmark:after {\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n}\n.spinner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -150px;\n  margin-top: -50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
